module.exports = __webpack_public_path__ + "static/img/son1.36e13853.jpg";